<script>
/**
 * ****************************************************************************
 * @description     :   Input phone Component
 * @created at      :   2023/07/17
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash-uuid';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input phone component
 */
var AnsPhone = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        inputClass: String,
        buttonClass: String,
        labelClass: String,
        value: String | Number,
        modelValue: String | Number,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        onChange: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: _.uuid(),
            newId2: _.uuid(),
            newId3: _.uuid()
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
            this.newId2 = this.id + '_part2';
            this.newId3 = this.id + '_part3';
        }
    },
    computed: {
        viewValue() {
            return this.modelValue ? this.modelValue : this.value;
        },
        viewValue1: {
            get() {
                const val = this.viewValue;
                const vals = val?.split('-');
                if (vals?.length > 1) {
                    return vals[0];
                } else if (val?.length > 0) {
                    return val.substring(0, val.length > 2 ? 2 : val.length);
                }
                return '';
            },
            set() {}
        },
        viewValue2: {
            get() {
                const val = this.viewValue;
                const vals = val?.split('-');
                if (vals?.length > 1) {
                    return vals[1];
                } else if (val?.length > 2) {
                    return val.substring(2, val.length > 6 ? 6 : val.length);
                }
                return '';
            },
            set() {}
        },
        viewValue3: {
            get() {
                const val = this.viewValue;
                const vals = val?.split('-');
                if (vals?.length > 2) {
                    return vals[2];
                } else if (val?.length > 6) {
                    return val.substring(6, val.length > 10 ? 10 : val.length);
                }
                return '';
            },
            set() {}
        }
    },
    methods: {
        /**
         * event block key on input
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        inputOnlyNumber(e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 13
                ) ||
                e.keyCode == 109
            ) {
                e.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * next to input part 2 of phone if done part 1
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        // eslint-disable-next-line no-unused-vars
        netInput(e) {
            // if (e.target.value.length == 2) {
            //     this.$refs.input2.focus();
            //     this.$refs.input2.setSelectionRange(
            //         0,
            //         this.$refs.input2.value.length
            //     );
            // }
        },
        /**
         * next to input part 3 of phone if done part 1. Or prev to input part 1 of phone if delete all part 2
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        // eslint-disable-next-line no-unused-vars
        prevOrNetInput(e) {
            // if (e.target.value.length == 4) {
            //     this.$refs.input3.focus();
            //     this.$refs.input3.setSelectionRange(
            //         0,
            //         this.$refs.input2.value.length
            //     );
            // }
            // if (
            //     (e.keyCode == 8 || e.keyCode == 46) &&
            //     e.target.value.length == 0
            // ) {
            //     this.$refs.input1.focus();
            // }
        },
        /**
         * prev to input part 2 of phone if delete all part 3
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        // eslint-disable-next-line no-unused-vars
        prevInput(e) {
            // if (
            //     (e.keyCode == 8 || e.keyCode == 46) &&
            //     e.target.value.length == 0
            // ) {
            //     this.$refs.input2.focus();
            // }
        },
        /**
         * check paste phone on part 1
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        onPaste1(e) {
            e.preventDefault();
            const val = e.clipboardData.getData('text').replace(/\D/g, '');
            let value = val;
            if (val > 2) {
                if (val > 6) {
                    value =
                        val.substring(0, 2) +
                        '-' +
                        val.substring(2, 6) +
                        '-' +
                        val.substring(2, 10);
                } else {
                    value =
                        val.substring(0, 2) +
                        '-' +
                        val.substring(2, val.length) +
                        '-' +
                        this.$refs.input3.value;
                }
            } else {
                value +=
                    '-' +
                    this.$refs.input2.value +
                    '-' +
                    this.$refs.input3.value;
            }
            this.updateInput(value, e);
        },
        /**
         * check paste phone on part 2
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        onPaste2(e) {
            e.preventDefault();
            const val = e.clipboardData.getData('text').replace(/\D/g, '');
            let value = val;
            if (val > 4) {
                value =
                    this.$refs.input1.value +
                    '-' +
                    val.substring(0, 4) +
                    '-' +
                    val.substring(4, val.length > 8 ? 8 : val.length);
            } else {
                value =
                    this.$refs.input1.value +
                    '-' +
                    value +
                    '-' +
                    this.$refs.input3.value;
            }
            this.updateInput(value, e);
        },
        /**
         * check paste phone on part 3
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        onPaste3(e) {
            e.preventDefault();
            const val = e.clipboardData.getData('text').replace(/\D/g, '');
            const value =
                this.$refs.input1.value +
                '-' +
                this.$refs.input2.value +
                '-' +
                val.substring(0, val.length > 4 ? 4 : val.length);
            this.updateInput(value, e);
        },
        /**
         * update part 1 of phone
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        updateInput1(e) {
            const value =
                this.$refs.input1.value +
                '-' +
                this.viewValue2 +
                '-' +
                this.viewValue3;
            this.updateInput(value, e);
        },
        /**
         * update part 2 of phone
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        updateInput2(e) {
            const value =
                this.viewValue1 +
                '-' +
                this.$refs.input2.value +
                '-' +
                this.viewValue3;
            this.updateInput(value, e);
        },
        /**
         * update part 3 of phone
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        updateInput3(e) {
            const value =
                this.viewValue1 +
                '-' +
                this.viewValue2 +
                '-' +
                this.$refs.input3.value;
            this.updateInput(value, e);
        },
        /**
         * update model of phone
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        updateInput(value, e) {
            this.$emit('update:modelValue', value == '--' ? '' : value);
            if (this.onChange) {
                this.onChange(e, value);
            }
        }
    }
};
export default AnsPhone;
</script>
